// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultHeader__container-ee1456 {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-inline-start: 9px;
  padding-inline-end: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.DefaultHeader__loading-bar-fa7673 {
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;AACF","sourcesContent":[".container {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-inline-start: 9px;\n  padding-inline-end: 24px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.loading-bar {\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DefaultHeader__container-ee1456`,
	"loading-bar": `DefaultHeader__loading-bar-fa7673`,
	"loadingBar": `DefaultHeader__loading-bar-fa7673`
};
module.exports = ___CSS_LOADER_EXPORT___;
